module.exports = __webpack_public_path__ + "images/logo.e2a293faebd345806ef606f1778c2d52.svg";